import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';
import iconMinusDisabled from './images/icon-minus-disabled.svg';
import iconPlusDisabled from './images/icon-plus-disabled.svg';
import iconMinus from './images/icon-minus.svg';
import iconPlus from './images/icon-plus.svg';

const Converters = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);
    const [isDisplayInfoPopup, setIsDisplayInfoPopup] = useState(false);
    const [numbers] = useState(['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שביעי', 'שמיני', 'תשיעי', 'עשירי']);

    return (
        <div className='converters'>
            <div>
                {
                    props.converters &&
                    props.converters.map((item, index) => {
                        return (
                            <div className='converter-items' key={index}>
                                {item.cmsData?.desktopImage && (
                                    <div className='converter-image'>
                                        <Image src={Config.epiBaseUrl + item.cmsData?.desktopImage} alt={item.name} />
                                    </div>
                                )}
                                <div className='converter-wrapper'>
                                    <div className='count-wrapper'>
                                        {
                                            isDisplayRemove(item.converterList) ? (
                                                <button className='btn-remove' style={{backgroundImage:iconMinus.bg()}} onClick={() => handleRemoveConverter(item.name, item.converterList)}></button>
                                            ) : (
                                                <div className='btn-remove disabled' style={{backgroundImage:iconMinusDisabled.bg()}}></div>
                                            )
                                        }
                                        <div className='count'> {getConvertersCount(item.converterList)} </div>
                                        {
                                            isDisplayAdd(item.converterList) ? (
                                                <button className='btn-add' style={{backgroundImage:iconPlus.bg()}} onClick={() => handleAddConverter(item.name, item.converterList)}></button>
                                            ) : (
                                                <div className='btn-add disabled' style={{backgroundImage:iconPlusDisabled.bg()}}></div>
                                            )
                                        }
                                    </div>
                                </div>

                                {
                                    item.converterList.filter((x) => x.action == 'Add').map((converter, i) => {
                                        return (
                                            <div className='converter-status' key={i}>
                                                <div className='line'></div>
                                                <div className='name-wapper'>ממיר {numbers[i]}</div>

                                                <div className='price'>
                                                    ₪{converter.price}
                                                    <div className='text-of-price'> לחודש </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }

                                {
                                    props.isLoadingShoppingCart &&
                                    <div className='loader'></div>
                                }

                            </div>
                        );
                    })
                }
            </div>

            {
                (props.convertersInfoPopupText || props.supportedTvPopupText) &&
                <div className='open-popup-link-wrapper'>
                    {/* <div className='open-popup-image'> <img src={Config.epiBaseUrl + props.supportedTvImage}></img> </div> */}
                    {
                        props.convertersInfoPopupText &&
                        <>
                            <div className='open-popup-link'><a href='#' onClick={() => setIsDisplayInfoPopup(true)}>למידע נוסף על ממירים בחבילה</a></div>
                            <PopUp showPopUp={isDisplayInfoPopup} onClose={() => setIsDisplayInfoPopup(false)} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: handleCloseInfoPopup }}>
                                <div dangerouslySetInnerHTML={{ __html: props.convertersInfoPopupText }}></div>
                            </PopUp>
                        </>
                    }
                    {
                        props.supportedTvPopupText &&
                        <>
                            <div className='open-popup-link'><a href='#' onClick={() => setIsDisplayPopup(true)}> {'אני רוצה לצפות ללא ממיר >>'}</a></div>
                            <PopUp showPopUp={isDisplayPopup} onClose={() => setIsDisplayPopup(false)} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: handleClosePopup }}>
                                <div className='popup-title'>האם הטלוויזיה שלי נתמכת?</div>
                                <div className='popup-image'><Image src={Config.epiBaseUrl + props.supportedTvImage} /></div>
                                <div dangerouslySetInnerHTML={{ __html: props.supportedTvPopupText }}></div>
                            </PopUp>
                        </>
                    }
                </div>
            }

        </div>
    );

    function getConvertersCount(converters) {
        const count = converters.filter((x) => x.action == 'Add').length;
        return count;
    }

    function handleAddConverter(name, converters) {
        const count = getConvertersCount(converters);

        let data = {
            name: name,
            count: count + 1,
            action: 'add'
        };
        props.onUpdateConverter(data);
    }

    function handleRemoveConverter(name, converters) {
        const count = getConvertersCount(converters);
        if (count == 0) { return; };

        let data = {
            name: name,
            count: count > 0 ? count - 1 : 0,
            action: 'remove'
        };
        props.onUpdateConverter(data);
    }

    function isDisplayAdd(converterList) {
        const converters = converterList.filter((x) => x.action == 'Add');
        const upperLimit = converterList[0].upperLimit;
        return (converters.length < props.maximumConverters && converters.length < upperLimit);
    }

    function isDisplayRemove(converterList) {
        const converters = converterList.filter((x) => x.action == 'Add');
        const lowerLimit = converterList[0].lowerLimit;
        return (converters.length > props.minimumConverters && converters.length > lowerLimit);
    }

    function handleClosePopup() {
        setIsDisplayPopup(false);
    }

    function handleCloseInfoPopup() {
        setIsDisplayInfoPopup(false);
    }
};

export default Converters;
